var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8281 2C7.31413 2 2.82812 6.486 2.82812 12V16.143C2.82812 17.167 3.72512 18 4.82812 18H5.82812C6.09334 18 6.3477 17.8946 6.53523 17.7071C6.72277 17.5196 6.82812 17.2652 6.82812 17V11.857C6.82812 11.5918 6.72277 11.3374 6.53523 11.1499C6.3477 10.9624 6.09334 10.857 5.82812 10.857H4.92013C5.47613 6.987 8.80613 4 12.8281 4C16.8501 4 20.1801 6.987 20.7361 10.857H19.8281C19.5629 10.857 19.3086 10.9624 19.121 11.1499C18.9335 11.3374 18.8281 11.5918 18.8281 11.857V18C18.8281 19.103 17.9311 20 16.8281 20H14.8281V19H10.8281V22H16.8281C19.0341 22 20.8281 20.206 20.8281 18C21.9311 18 22.8281 17.167 22.8281 16.143V12C22.8281 6.486 18.3421 2 12.8281 2Z",
    fill: "#AFD34F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_4982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8281 15.5C15.0371 15.5 16.8281 13.933 16.8281 12C16.8281 10.067 15.0371 8.5 12.8281 8.5C10.6191 8.5 8.82812 10.067 8.82812 12C8.82812 12.88 9.19963 13.685 9.81313 14.3C9.76463 14.808 9.60462 15.365 9.42763 15.783C9.38813 15.876 9.46463 15.98 9.56413 15.964C10.6921 15.779 11.3626 15.495 11.6541 15.347C12.0371 15.4491 12.4318 15.5006 12.8281 15.5Z",
    fill: "#AFD34F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_4982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(8.82812 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.3491020e1e59e63c1b6f6d7f411c17ef.svg";
export { ForwardRef as ReactComponent };